import React from 'react';
import { format } from 'react-string-format';
import Pusher from 'pusher-js';
import {NavLink} from "react-router-dom";
import ManageGameGeneral from "./ManageGame/ManageGameGeneral";
import GameChat from "./Chat/GameChat";
import axios from "axios";
import {Card, Col, Container, ListGroup, Row, Tab, Tabs} from "react-bootstrap";
import Carousel from 'react-bootstrap/Carousel'

var fileDownload = require('js-file-download');

export default class Game extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            userId: null,
            userName: null,
            loginError: null,
            gameStatsForUser: null,
            gameStatsForUserIsLoaded: false,
            chatId: null,
            paymentData: null,
            paymentDataIsLoaded: false,
            item: {},
            os: [],
            downloadValue: 0,
        };
    }

    loadPaymentDataForUser(userId){
        fetch(process.env.REACT_APP_API_URL + "/my-account/"+userId+"/card/default", {
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        })
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        paymentData: result,
                        paymentDataIsLoaded: true
                    });
                },

                (error) => {
                    console.log(error);

                    this.setState({
                        paymentDataIsLoaded: false,
                        error
                    });
                }
            )
    }

    loadGameStatsForUser(userId){
        fetch(process.env.REACT_APP_API_URL + "/customer/game/"+this.props.gameId+"/stats/user/"+userId, {
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        })
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        gameStatsForUserIsLoaded: true,
                        gameStatsForUser: result
                    });
                },

                (error) => {
                    console.log(error);

                    this.setState({
                        gameStatsForUserIsLoaded: false,
                        error
                    });
                }
            )
    }

   componentDidMount() {
        fetch(process.env.REACT_APP_API_URL + '/my-account/try-login-via-cache', {
            method: "POST",
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        }).then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        userId: result.id,
                        userName: result.first_name
                    });

                    this.loadGameStatsForUser(result.id);
                    this.loadPaymentDataForUser(result.id);
                },
                (error) => {
                    console.log(error);

                    this.setState({
                        loginError: "unauthorized",
                    });
                }
            );

        fetch(process.env.REACT_APP_API_URL + "/customer/game/"+this.props.gameId+"/stats", {
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        })
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        isLoaded: true,
                        item: result
                    });
                },

                (error) => {
                    console.log(error);

                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )

        fetch(process.env.REACT_APP_API_URL + "/customer/game/"+this.props.gameId+"/os", {
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        })
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        os: result
                    });
                },

                (error) => {
                    console.log(error);
                    this.setState({
                        error
                    });
                }
            )

        this.loadChat();
    }

    async handleSubmit(e) {
        e.preventDefault();

        let card = null;
        let address = null;

        var progressBar = document.getElementById("file_download_progress");
        var downloadButton = document.getElementById("download_button");

        progressBar.style.visibility = 'visible';
        downloadButton.style.visibility = 'hidden';

        if ((this.state.item.game.paid_product ? this.state.item.game.paid_product.price > 0 : false) && !this.state.paymentData.hasOwnProperty('number')) {
            card = {
                'number': e.target.cardnumber.value,
                'cvc': e.target.cardcvc.value,
                'exp_month': e.target.expmonth.value,
                'exp_year': e.target.expyear.value
            };
            address = {
                'line1': e.target.address.value,
                'postal_code': e.target.zip.value,
                'country': e.target.country.value,
                'state': e.target.state.value,
                'city': e.target.city.value
            };
        }

        const body = {
            'os': e.target.os.value,
            'user_id': this.state.userId.toString(),
            'payment': {
                'card': card,
                'address': address
            }
        };

        fetch(format(process.env.REACT_APP_API_URL + '/customer/game/{0}/download', e.target.game_id.value), {
            method: "POST",
            body: JSON.stringify(body),
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`},
        }).then(res => res.json())
            .then(
                async (result) => {
                    console.log(result.filepath);

                    /*const link = document.createElement('a');
                    link.href = result.filepath;
                    link.setAttribute('download', 'file.apk'); //or any other extension
                    document.body.appendChild(link);
                    link.click();*/

                    await axios({
                        url: result.filepath,//"https://i.ibb.co/6JNT96R/Desc1400-800.png",
                        method: "GET",
                        headers: {
                            'Access-Control-Allow-Origin': '*',
                            'Access-Control-Allow-Methods': 'GET',
                        },
                        responseType: "blob", // important
                        onDownloadProgress: (progressEvent) => {
                            this.setState({
                                downloadValue: Math.round((progressEvent.loaded * 100) / progressEvent.total),
                            });

                            //console.log(Math.round((progressEvent.loaded * 100) / progressEvent.total)); // you can use this to show user percentage of file downloaded
                        }
                    }).then(response => {
                        const link = document.createElement('a');
                        link.href = result.filepath;
                        link.setAttribute('download', 'file.apk'); //or any other extension
                        document.body.appendChild(link);
                        link.click();

                        progressBar.style.visibility = 'hidden';
                        downloadButton.style.visibility = 'visible';
                    })
                },
                (error) => {
                    console.log(error.toString());
                }
            );
    }

    like(e){
        e.preventDefault();

        const body = {'rate': 1, 'user_id': this.state.userId};

        fetch(format(process.env.REACT_APP_API_URL + '/customer/game/{0}/rate', this.state.item.game.id), {
            method: "POST",
            body: JSON.stringify(body),
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`},
        }).then(
            (result) => {
                this.loadGameStatsForUser(this.state.userId);
            },
            (error) => {
                this.setState({
                    error: error
                })
            }
        );
    }

    dislike(e){
        e.preventDefault();

        const body = {'rate': -1, 'user_id': this.state.userId};

        fetch(format(process.env.REACT_APP_API_URL + '/customer/game/{0}/rate', this.state.item.game.id), {
            method: "POST",
            body: JSON.stringify(body),
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`},
        }).then(
            (result) => {
                this.loadGameStatsForUser(this.state.userId);
            },
            (error) => {
                this.setState({
                    error: error
                })
            }
        );
    }

    addToFavourites(e){
        e.preventDefault();

        const body = {'user_id': this.state.userId};

        fetch(format(process.env.REACT_APP_API_URL + '/customer/game/{0}/add-to-favourites', this.state.item.game.id), {
            method: "PATCH",
            body: JSON.stringify(body),
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`},
        }).then(
            (result) => {
                this.loadGameStatsForUser(this.state.userId);
            },
            (error) => {
                this.setState({
                    error: error
                })
            }
        );
    }

    removeFromFavourites(e){
        e.preventDefault();

        const body = {'user_id': this.state.userId};

        fetch(format(process.env.REACT_APP_API_URL + '/customer/game/{0}/remove-from-favourites', this.state.item.game.id), {
            method: "PATCH",
            body: JSON.stringify(body),
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`},
        }).then(
            (result) => {
                this.loadGameStatsForUser(this.state.userId);
            },
            (error) => {
                this.setState({
                    error: error
                })
            }
        );
    }

    loadChat(){
        fetch(process.env.REACT_APP_API_URL + "/chat/game/"+this.props.gameId.toString() + "/id", {
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        })
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        chatId: result.chat_id,
                    });
                },

                (error) => {
                }
            )
    }

    render() {
        const { paymentData, paymentDataIsLoaded, chatId, error, isLoaded, item, os, userId, userName, loginError, gameStatsForUser, gameStatsForUserIsLoaded } = this.state;

        if(error){
            return <h1>Error occured</h1>
        }

        let descriptionImages = null;
        if (isLoaded && item.game && item.game.game_page && item.game.game_page.description_images) {
            descriptionImages = <div class="alert alert-success" style={{
                width: "100%",
                overflowX: "auto",
                whiteSpace: "nowrap",
            }}>
                {item.game.game_page.description_images.map(img => (
                <img style={{borderRadius: 5, marginRight: 5}} width="450" src={img}></img>
                ))}
            </div>;
        }

        let paymentDataFormatted = null;
        if (gameStatsForUserIsLoaded && paymentDataIsLoaded && paymentData.hasOwnProperty('number')) {
            paymentDataFormatted = <div>
                <h2>${item.game.paid_product ? item.game.paid_product.price : 0}</h2>
                <strong>{paymentData.number}</strong>
                <NavLink className="btn btn-primary" to={{
                    pathname: '/account/' + userId.toString() + '/payment',
                }}>
                    Edit
                </NavLink>
            </div>
        }

        let dataForAuthorizedUser = [];

        if (isLoaded && loginError) {
            dataForAuthorizedUser = <div>{item.game.is_game_release_enabled ? (<span><NavLink
                to="/account" className="btn btn-danger"
            >
                Login to download
            </NavLink><br/><br/></span>) : <empty></empty>
            }
                {
                    item.game.game_links ? <div>
                            <Tabs
                                defaultActiveKey="main"
                                id="uncontrolled-tab-example"
                                className="mb-3"
                            >
                                <Tab eventKey="main" title="Stores">
                                    {item.game.game_links.google_play
                                        ? <span>
                                        <a href={item.game.game_links.google_play}>
                                            <img style={{
                                                width:"135px",
                                                height:"40px",
                                                marginRight: "35px",
                                                marginBottom: "35px"
                                            }} src="https://www.google.com/intl/en/cast/about/static/images/download-badges/android-download.png" alt="Google Play"/>
                                        </a>
                                    </span>
                                        : <br/>
                                    }

                                    {item.game.game_links.app_store
                                        ? <span>
                                        <a href={item.game.game_links.google_play}><img style={{
                                            width:"135px",
                                            height:"40px",
                                            marginRight: "35px",
                                            marginBottom: "35px"
                                        }} src="https://www.pngmart.com/files/10/Download-On-The-App-Store-PNG-Image.png" alt="App Store"/>
                                        </a>
                                        </span>
                                        : <br/>
                                    }

                                    {item.game.game_links.microsoft_store
                                        ? <span>
                                        <a href={item.game.game_links.microsoft_store}>
                                            <img style={{
                                                width:"135px",
                                                height:"40px",
                                                marginRight: "35px",
                                            }} src="https://www.qooco.com/wp-content/uploads/2021/12/windows-22.png" alt="Microsoft Store"/>
                                        </a>
                                    </span>
                                        : ""
                                    }
                                    <br/>
                                </Tab>

                                <Tab eventKey="other" title="Other">
                                    {item.game.game_links.steam
                                        ? <div>
                                            <a class="btn btn-outline-dark" href={item.game.game_links.steam}>Steam</a>
                                            <br/><br/>
                                        </div>: ""
                                    }

                                    {item.game.game_links.epic_games_store
                                        ? <div>
                                            <a class="btn btn-outline-dark" href={item.game.game_links.epic_games_store}>Epic Games</a>
                                            <br/><br/>
                                        </div>
                                        : ""
                                    }

                                    {item.game.game_links.aptoide
                                        ? <div>
                                            <a class="btn btn-outline-dark" href={item.game.game_links.aptoide}>Aptoide</a>
                                            <br/><br/>
                                        </div>
                                        : ""
                                    }

                                    {item.game.game_links.cydia
                                        ? <div>
                                            <a class="btn btn-outline-dark" href={item.game.game_links.cydia}>Cydia</a>
                                            <br/><br/>
                                        </div>
                                        : ""
                                    }

                                    {item.game.game_links.galaxy_app_store
                                        ? <div>
                                            <a class="btn btn-outline-dark" href={item.game.game_links.galaxy_app_store}>Galaxy App Store</a>
                                            <br/><br/>
                                        </div>
                                        : ""
                                    }

                                    {item.game.game_links.amazon_app_store
                                        ? <div>
                                            <a class="btn btn-outline-dark" href={item.game.game_links.amazon_app_store}>Amazon App Store</a>
                                            <br/><br/>
                                        </div>
                                        : ""
                                    }

                                    {item.game.game_links.tweak_box
                                        ? <div>
                                            <a class="btn btn-outline-dark" href={item.game.game_links.tweak_box}>Tweak box</a>
                                            <br/><br/>
                                        </div>
                                        : ""
                                    }
                                </Tab>
                            </Tabs>
                        </div>
                    : <empty/>
                }
            </div>
        } else if (gameStatsForUserIsLoaded) {
            dataForAuthorizedUser = <div class="row">
                {(os.length > 0 && item.game.is_game_release_enabled) ? <Carousel class="col-sm-2" variant="dark" slide={true}>
                    {os.map(osItem => (
                        <Carousel.Item style={{
                            overflowX: "auto"
                        }}>
                            <img style={{
                                opacity: 0.5,
                                maxWidth: "100%",
                                maxHeight: "100%"
                            }}
                                src={osItem.image}
                                alt=""
                                width="100%"
                                height="280px"
                                align="center"
                            />
                            <Carousel.Caption style={{
                                overflowX: "auto"
                            }}>
                                <h3>{osItem.os.toUpperCase()}</h3>
                        <form onSubmit={this.handleSubmit.bind(this)}>

                            <input hidden type="text" name="os" value={osItem.field}/>
                            <input hidden type="number" name="game_id" value={item.game.id}/>
                            {((item.game.paid_product ? item.game.paid_product.price > 0 : false) && gameStatsForUser.downloaded === 0) ?
                                <div>
                                    {paymentDataFormatted !== null ? paymentDataFormatted : <div>
                                        <h2>${item.game.paid_product.price}</h2>
                                        <NavLink className="btn btn-primary" to={{
                                            pathname: '/account/' + userId.toString() + '/payment',
                                        }}>
                                            Add credit card
                                        </NavLink>

                                        {/*
                                            <label htmlFor="ccnum">Credit card number</label>

                                        <input class="form-control" type="text" id="ccnum" name="cardnumber" placeholder="1111-2222-3333-4444"/>
                                        <br/>
                                        <label htmlFor="expmonth">Exp Month</label>
                                        <input class="form-control" type="text" id="expmonth" name="expmonth" placeholder="September"/>
                                        <br/>
                                        <div className="row">
                                            <div className="col-50">
                                                <label htmlFor="expyear">Exp Year</label>
                                                <input class="form-control" type="text" id="expyear" name="expyear" placeholder="2023"/>
                                            </div>
                                            <div className="col-50">
                                                <label htmlFor="cvv">CVV</label>
                                                <input class="form-control" type="text" id="cvv" name="cardcvc" placeholder="352"/>
                                            </div>
                                        </div>
                                        <div className="col-50">
                                            <h3>Billing Address</h3>
                                            <label htmlFor="adr">Address</label>
                                            <input class="form-control" type="text" id="adr" name="address" placeholder="542 W. 15th Street"/>
                                            <label htmlFor="city">City</label>
                                            <input class="form-control" type="text" id="city" name="city" placeholder="New York"/>

                                            <div className="row">
                                                <div className="col-50">
                                                    <label htmlFor="state">State</label>
                                                    <input class="form-control" type="text" id="state" name="state" placeholder="NY"/>
                                                </div>
                                                <div className="col-50">
                                                    <label htmlFor="state">Country</label>
                                                    <input class="form-control" type="text" id="country" name="country" placeholder="USA"/>
                                                </div>
                                                <div className="col-50">
                                                    <label htmlFor="zip">Zip</label>
                                                    <input class="form-control" type="text" id="zip" name="zip" placeholder="10001"/>
                                                </div>
                                            </div>
                                        </div>*/}
                                    </div>
                                    }
                                </div>
                                : <br/>}

                            {gameStatsForUserIsLoaded && ((paymentDataIsLoaded && paymentData.hasOwnProperty('number')) || (item.game.paid_product ? item.game.paid_product.price === 0 : true)) ?
                                <input id="download_button" class="btn btn-success" type="submit" value={gameStatsForUser.download_state[osItem.os]}/>
                                :
                                <span></span>
                            }
                        </form>
                            </Carousel.Caption>
                        </Carousel.Item>
                    ))}
                </Carousel>
                    :
                    <div>
                        {
                            item.game.game_links ? <div>
                                    <Tabs
                                        defaultActiveKey="main"
                                        id="uncontrolled-tab-example"
                                        className="mb-3"
                                    >
                                        <Tab eventKey="main" title="Stores">
                                            {item.game.game_links.google_play
                                                ? <span>
                                        <a href={item.game.game_links.google_play}>
                                            <img style={{
                                                width:"135px",
                                                height:"40px",
                                                marginRight: "35px",
                                                marginBottom: "35px"
                                            }} src="https://www.google.com/intl/en/cast/about/static/images/download-badges/android-download.png" alt="Google Play"/>
                                        </a>
                                    </span>
                                                : <br/>
                                            }

                                            {item.game.game_links.app_store
                                                ? <span>
                                        <a href={item.game.game_links.google_play}><img style={{
                                            width:"135px",
                                            height:"40px",
                                            marginRight: "35px",
                                            marginBottom: "35px"
                                        }} src="https://www.pngmart.com/files/10/Download-On-The-App-Store-PNG-Image.png" alt="App Store"/>
                                        </a>
                                        </span>
                                                : <br/>
                                            }

                                            {item.game.game_links.microsoft_store
                                                ? <span>
                                        <a href={item.game.game_links.microsoft_store}>
                                            <img style={{
                                                width:"135px",
                                                height:"40px",
                                                marginRight: "35px",
                                            }} src="https://www.qooco.com/wp-content/uploads/2021/12/windows-22.png" alt="Microsoft Store"/>
                                        </a>
                                    </span>
                                                : ""
                                            }
                                            <br/>
                                        </Tab>

                                        <Tab eventKey="other" title="Other">
                                            {item.game.game_links.steam
                                                ? <div>
                                                    <a class="btn btn-outline-dark" href={item.game.game_links.steam}>Steam</a>
                                                    <br/><br/>
                                                </div>: ""
                                            }

                                            {item.game.game_links.epic_games_store
                                                ? <div>
                                                    <a class="btn btn-outline-dark" href={item.game.game_links.epic_games_store}>Epic Games</a>
                                                    <br/><br/>
                                                </div>
                                                : ""
                                            }

                                            {item.game.game_links.aptoide
                                                ? <div>
                                                    <a class="btn btn-outline-dark" href={item.game.game_links.aptoide}>Aptoide</a>
                                                    <br/><br/>
                                                </div>
                                                : ""
                                            }

                                            {item.game.game_links.cydia
                                                ? <div>
                                                    <a class="btn btn-outline-dark" href={item.game.game_links.cydia}>Cydia</a>
                                                    <br/><br/>
                                                </div>
                                                : ""
                                            }

                                            {item.game.game_links.galaxy_app_store
                                                ? <div>
                                                    <a class="btn btn-outline-dark" href={item.game.game_links.galaxy_app_store}>Galaxy App Store</a>
                                                    <br/><br/>
                                                </div>
                                                : ""
                                            }

                                            {item.game.game_links.amazon_app_store
                                                ? <div>
                                                    <a class="btn btn-outline-dark" href={item.game.game_links.amazon_app_store}>Amazon App Store</a>
                                                    <br/><br/>
                                                </div>
                                                : ""
                                            }

                                            {item.game.game_links.tweak_box
                                                ? <div>
                                                    <a class="btn btn-outline-dark" href={item.game.game_links.tweak_box}>Tweak box</a>
                                                    <br/><br/>
                                                </div>
                                                : ""
                                            }
                                        </Tab>
                                    </Tabs>
                                </div>
                                : <empty/>
                        }
                    </div>
                }
                <div style={{visibility: "hidden", width: "100%", marginLeft: "25%"}} id="file_download_progress">
                    <br/>
                    <progress color="green" value={this.state.downloadValue} max="100" />
                </div>
            </div>
        }

        let gameStatsForUserFormatted = <span></span>;

        if (gameStatsForUserIsLoaded) {
            gameStatsForUserFormatted = <div class="row alert alert-warning">
                {/*<h3>Is liked: {gameStatsForUser.liked}</h3>
                <h3>Is downloaded: {gameStatsForUser.downloaded}</h3>
                <h3>Is favourite: {gameStatsForUser.favourite}</h3>*/}
                <div>
                    {gameStatsForUser.liked ?
                        <form onSubmit={this.dislike.bind(this)}>
                            <input class="btn btn-outline-danger" type="submit" value="Remove like"/>
                        </form>
                        :
                        <form onSubmit={this.like.bind(this)}>
                            <input class="btn btn-danger" type="submit" value="Like"/>
                        </form>
                    }
                </div>
                <br/><br/>
                <div>
                    {gameStatsForUser.favourite ?
                        <form onSubmit={this.removeFromFavourites.bind(this)}>
                            <input class="btn btn-outline-success" type="submit" value="Remove from favourites"/>
                        </form>
                        :
                        <form onSubmit={this.addToFavourites.bind(this)}>
                            <input class="btn btn-success" type="submit" value="Add to favourites"/>
                        </form>
                    }
                </div>
                <br/><br/>
                {chatId !== -1 ? <div>
                    <button class="btn btn-primary" id='chat-open-button' onClick={(e) => {
                        let block = document.getElementById('chat');

                        let longDesc = document.getElementById('long_description')

                        if (block.style.display === 'none') {
                            block.style.display = 'block';
                            longDesc.style.display = 'none';
                        } else {
                            block.style.display = 'none';
                            longDesc.style.display = 'block';
                        }
                    }}>Chat</button>
                    <div style={{display: 'none'}} id='chat'>
                        <br/>
                        <GameChat gameId={this.props.gameId} userId={userId} userName={userName} chatId={chatId}/>
                    </div>
                </div> : <hr/>
                }
            </div>
        }

        let content = null;
        if (error) {
            content = <div>{error ? <div className="alert alert-danger">
                <p>Session token has expired. Please, <a href="/account">login</a> again</p>
            </div> :<empty/>}</div>;
        } else if (!isLoaded) {
            content = <div>Loading...</div>;
        } else {
            content = (
                <div>
                    <img style={{
                        width: "100%",
                        opacity: 0.6,
                        maxWidth: "100%",
                        height: "100%",
                        maxHeight: "100%",
                        minHeight: "100%",
                        borderRadius: 9,
                        borderColor: "darkgray",
                    }} src={item.game.game_page ? item.game.game_page.background_image_url : ''} width="400"></img>
                    <br/><br/>
                    <div class="row">
                        <div className="col-sm-4">
                            <Card style={{ width: '100%' }}>
                                <Card.Img style={{
                                    width: "100%",
                                    maxWidth: "100%",
                                    height: "100%",
                                    maxHeight: "100%",
                                    minHeight: "100%",
                                    borderRadius: 9,
                                    borderColor: "darkgray",
                                }} width="100%" height="200px" variant="top" src={item.game.game_page ? item.game.game_page.icon_url : ''} />
                                <Card.Body>
                                    <Card.Title>{item.game.name}</Card.Title>
                                    <Card.Text>
                                        {item.game.game_page ? item.game.game_page.short_description : ''}
                                    </Card.Text>
                                </Card.Body>
                                <ListGroup className="list-group-flush">
                                    <ListGroup.Item>{item.game.genre}</ListGroup.Item>
                                    <ListGroup.Item>{item.game_category ? "Category: " + item.game_category.name : ""}</ListGroup.Item>

                                    <ListGroup.Item>
                                        <img width="35" src="https://www.freeiconspng.com/uploads/downloads-icon-15.png"/>
                                        <span style={{fontSize: 20}}>{item.downloads}</span>

                                        <img style={{
                                            marginLeft: 20
                                        }} width="35" src="https://www.pngall.com/wp-content/uploads/3/Heart-PNG-Photo-Image.png"/>
                                        {
                                            item.likes_percentage > -1 ?
                                                <span style={{fontSize: 20}}>{item.likes_percentage}%</span>
                                                :<span></span>
                                        }
                                    </ListGroup.Item>
                                </ListGroup>
                            </Card>
                        </div>
                        <div className="col-sm">
                            {gameStatsForUserFormatted}
                            <p id="long_description" align="left" class="alert alert-warning">{item.game.game_page ? item.game.game_page.long_description : ''}</p>
                        </div>
                        <div className="col-sm-3">
                            {dataForAuthorizedUser}
                        </div>
                    </div>
                    <br/>
                    <br/>

                    {descriptionImages}
                    <br/>
                </div>
            );
        }

        return <Container>
            <Row>
                <Col>
                    {content}
                </Col>
            </Row>
        </Container>;
    }
}
